import dayjs from 'dayjs';
import { ISubmissionPagedRequest } from '../../../model/ser/submission/request/submission-paged-request';

export const PERIOD_ERROR = 'A data final deve ser maior ou igual à inicial';

export interface PeriodErrors {
    send?: string;
    publish?: string;
}

function invalid(start?: string, end?: string): boolean {
    return !!start && !!end && dayjs(end).isBefore(dayjs(start), 'day');
}

export function validatePeriods(params: ISubmissionPagedRequest): PeriodErrors {
    const errors: PeriodErrors = {};
    if (invalid(params.startDate, params.endDate)) errors.send = PERIOD_ERROR;
    if (invalid(params.publishStartDate, params.publishEndDate)) errors.publish = PERIOD_ERROR;
    return errors;
}

export const EMPTY_FILTERS: Partial<ISubmissionPagedRequest> = {
    startDate: undefined, endDate: undefined, publishStartDate: undefined, publishEndDate: undefined,
    statusIds: [], types: [], vehicleId: undefined, batchId: undefined, clientId: undefined, title: undefined, content: undefined,
};

// Parâmetros de navegação vindos do envio e do dashboard: ?id=, ?lote=, ?status=&inicio=&fim=
export interface SearchDeepLink {
    submissionId?: number;
    batchId?: number;
    filters: Partial<ISubmissionPagedRequest>;
}

// Id inteiro positivo; qualquer outro valor é ignorado
function parseId(value: string | null): number | undefined {
    const id = Number(value);
    return value && Number.isInteger(id) && id > 0 ? id : undefined;
}

export function parseDeepLink(search: URLSearchParams): SearchDeepLink {
    const filters: Partial<ISubmissionPagedRequest> = {};
    const status = parseId(search.get('status'));
    if (status) filters.statusIds = [status];
    if (search.get('inicio')) filters.startDate = search.get('inicio') as string;
    if (search.get('fim')) filters.endDate = search.get('fim') as string;

    return {
        submissionId: parseId(search.get('id')),
        batchId: parseId(search.get('lote')),
        filters,
    };
}
